exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-edit-builder-symbol-tsx": () => import("./../../../src/pages/edit-builder-symbol.tsx" /* webpackChunkName: "component---src-pages-edit-builder-symbol-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-templates-catch-all-tsx": () => import("./../../../src/templates/CatchAll.tsx" /* webpackChunkName: "component---src-templates-catch-all-tsx" */)
}

